module.exports = __webpack_public_path__ + "static/img/cat.e47106a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/cat.png
// module id = dF3P
// module chunks = 0